let prices = Array.from(document.querySelectorAll('.price-js'))
if (prices) {
  prices.forEach((price) => {
    let newPrice = 0
    price.addEventListener('dblclick', (e) => {
      e.preventDefault()
      e.stopPropagation()
      let token = price.dataset['token']
      let oldPrice = price.innerHTML
      if (price.querySelector('i')) {
        oldPrice = 0
      }
      let url = price.dataset['action']
      price.innerHTML = `
            <form action="${url}" enctype="multipart/form-data" method="POST" class="form_price-js" >
                <input type="hidden" name="_token" value="${token}">
                <input name="_method" type="hidden" value="PUT">
                <input type="number" class="input_price-js" value="${oldPrice}"></input>
            </form>`
      let inputNumber = document.querySelector('.input_price-js')
      inputNumber.focus()
      inputNumber.addEventListener('dblclick', (e) => {
        e.stopPropagation()
        e.preventDefault()
      })
      let form = inputNumber.parentNode
      let data = new FormData(form)
      form.addEventListener('submit', async e => {
        e.preventDefault()
        let url = form.getAttribute('action')
        let response = await fetch(url, {
          method: 'POST',
          headers: {
            'X-Request-Width': 'xmlhttprequest'
          },
          body: data
        })
        console.log(response.data)
        if (response.ok === true) {
          if (newPrice === null || newPrice === 0 || newPrice === '0' || isNaN(newPrice)) {
            price.innerHTML = `<i class="fa fa-times"></i>`
          } else {
            price.innerHTML = newPrice
          }
        }
      })
      inputNumber.addEventListener('blur', e => {
        e.preventDefault()
        newPrice = parseInt(inputNumber.value, 10)
        let numberPrice = price.dataset['price']
        data.append('price', newPrice)
        data.append('numberPrice', numberPrice)
        const domEvent = document.createEvent('Event')
        domEvent.initEvent('submit', false, true)
        e.target.closest('form').dispatchEvent(domEvent)
      })
    })
  })
}
